import { Component, OnInit, Input } from "@angular/core";
import { Dialog, SharedModule } from "@bb-vendure/admin-ui/core";
import { ProductVariantSelectorComponent } from "./product-variant-selector/product-variant-selector.component";
import { FormBuilder, Validators } from "@angular/forms";

@Component({
  //selector: "approve-inbound-dialog",
  templateUrl: "./update-sku-dialog.component.html",
  standalone: true,
  imports: [SharedModule, ProductVariantSelectorComponent],
})
export class UpdateSkuDialogComponent implements Dialog, OnInit {
  constructor(protected formBuilder: FormBuilder) {}
  ngOnInit(): void {
    this.updateForm.patchValue({
      currentQuantity: this.currentQuantity ?? 1,
      variant: this.currentVariant ?? null,
    });
  }
  resolveWith: (result?: any) => void;

  @Input()
  title: string;

  @Input()
  orderId: string;

  @Input()
  orderCode: string;

  @Input()
  currentVariant: any;

  @Input()
  currentQuantity: any;

  updateForm = this.formBuilder.group({
    currentQuantity: [1, Validators.min(1)],
    variant: [null, Validators.required],
  });

  newVariant: any;

  addProductVariant(event: any) {
    this.newVariant = event;

    this.updateForm.patchValue({
      variant: event,
    });
    this.updateForm.markAsDirty();
  }

  currentName() {
    if (this.currentVariant) {
      return `${this.currentVariant.translations[0].name} | SKU : ${this.currentVariant.sku}`;
    }
    return "";
  }

  save() {
    const data = this.updateForm.value;

    this.resolveWith({
      variant: this.newVariant,
      quantity: data.currentQuantity,
    });
  }

  cancel() {
    this.resolveWith();
  }

  test() {
    console.log(this.updateForm);
  }
}
